/** Window used when a spotlight doesn't configure its own cap. */
const DEFAULT_FREQUENCY_CAP_HOURS = 24;

export function getExpirationMs(
  frequencyCapHours: number | null | undefined,
): number {
  const hours = frequencyCapHours ?? DEFAULT_FREQUENCY_CAP_HOURS;
  return hours * 60 * 60 * 1000;
}

/**
 * Whether a spotlight last shown at `lastShownAt` is still inside its frequency
 * cap and must stay suppressed. A spotlight the visitor has never seen is never
 * capped.
 */
export function isWithinFrequencyCap({
  lastShownAt,
  frequencyCapHours,
  now,
}: {
  lastShownAt: Date | undefined;
  frequencyCapHours: number | null | undefined;
  now: number;
}): boolean {
  if (!lastShownAt) {
    return false;
  }
  return now - lastShownAt.getTime() <= getExpirationMs(frequencyCapHours);
}
